export const API_DETAILS = {
    service_api: "/api/v1/"
}